import React from 'react'
import {
  CustomLabel,
  LabelHazardousGoods,
  LabelInCart,
  LabelTimesPurchased,
  LabelTopseller,
  LabelDeals,
  LabelSustainability,
  LabelNewArrival,
  LabelNewInStock,
  LabelSale,
  LabelDealsInShop,
} from '../../label/Label'
import { extractNumberFromText } from '@obeta/utils/lib/extractNumberFromText'
import { LabelUnion } from '@obeta/schema'
import styles from './retrieveLabels.module.scss'
import { TecSelectIcon, VoltimumSmallIcon } from '../../icons'

export const retrieveLabels = (
  showIsInCart: boolean,
  labels: LabelUnion[],
  showTecSelect: boolean,
  showVoltimum: boolean,
  maxCount?: number
): JSX.Element[] => {
  if (!labels) return []
  let labelElements = showIsInCart ? [<LabelInCart key={'label-in-cart'} />] : []

  const countToSubtractFromMaxCount = showIsInCart ? 1 : 0
  const filteredLabels = maxCount ? labels.slice(0, maxCount - countToSubtractFromMaxCount) : labels

  labelElements = labelElements.concat(
    filteredLabels
      .map((label) => {
        if (label.__typename === 'CustomLabel') {
          return (
            <CustomLabel
              key={`${label.text}-${label.color}`}
              color={label.color}
              text={label.text}
            />
          )
        } else if (label.__typename === 'Label') {
          switch (label.type) {
            case 'boughtXTimes':
              return (
                <LabelTimesPurchased
                  key={'boughtXTimes'}
                  count={extractNumberFromText(label.text)}
                />
              )
            case 'hazardousGoods':
              return <LabelHazardousGoods key={'hazardousGoods'} />
            case 'topseller':
              return <LabelTopseller key={'topSeller'} />
            case 'deals':
              return <LabelDeals key={'deals'} />
            case 'sustainable':
              return <LabelSustainability key={'sustainable'} />
            case 'new':
              return <LabelNewArrival key={'new'} />
            case 'newInStock':
              return <LabelNewInStock key={'newInStock'} />
            case 'clearance':
              return <LabelSale key={'clearance'} />
            case 'webshopExclusive':
              return <LabelDealsInShop key={'webshopExclusive'} />
            default:
              return null
          }
        }
        return null
      })
      .filter(Boolean) as JSX.Element[]
  )
  if (showTecSelect && !labelElements.some((item) => item.key === 'tec-select')) {
    labelElements.push(<TecSelectIcon key="tec-select" />)
  }
  if (showVoltimum && !labelElements.some((item) => item.key === 'voltimum')) {
    labelElements.push(
      <div key="voltimum" className={styles.voltimumIcon}>
        <VoltimumSmallIcon />
      </div>
    )
  }

  return labelElements
}
